import { ARRIVING_LABEL, AT_STOP_LABEL, DEPARTED_LABEL } from '../constants'

export function getStatusText(isAtStop, isArriving, isDeparted) {
  if (isAtStop) {
    return AT_STOP_LABEL
  } else if (isArriving) {
    return ARRIVING_LABEL
  } else if (isDeparted) {
    return DEPARTED_LABEL
  }
  return ''
}
